// extracted by mini-css-extract-plugin
export default {"collapse":"EditCandidateAttachmentPage_collapse__38jLq"};